module.exports = __webpack_public_path__ + "static/media/terrace-5.4d4ef834.jpg";